import React, { useState } from 'react'
import { useGetTreeById } from '../../../reducers/trees_hooks'
import { Box, Button } from '@mui/material'
import { EditableCurriculaTree } from '../../tree/EditableCurriculaTree'
import { TreeIdInput } from '../../tree/navigationHelpers/TreeNodeRouter'
import { useSwapEditableTreeWithRefresh } from './utility'
import { useProductWithPrimaryTreeForId } from '../../../api/tree.hooks'

export function EditableTreeSwap({ productId }: { productId: number }) {
  const [swapping, setSwapping] = useState(false)
  const [treeIds, setTreeIds] = useState<{
    treeId?: string
    versionId?: string
  }>({})
  const swapFunc = useSwapEditableTreeWithRefresh()
  const product = useProductWithPrimaryTreeForId(productId)
  const hasEditableTree = !!product?.editable_tree
  const label = hasEditableTree ? 'Swap Editable Tree' : 'Add Editable Tree'

  const { tree } = useGetTreeById(treeIds)

  if (!swapping) {
    return (
      <Box>
        <Button onClick={() => setSwapping(true)}>{label}</Button>
      </Box>
    )
  }

  const cancel = () => {
    setTreeIds({})
    setSwapping(false)
  }

  const doIt = async () => {
    const { treeId, versionId } = treeIds
    if (!treeId || !versionId) return
    await swapFunc(productId, { treeId, versionId })
    cancel()
  }

  const TreeIds = () => {
    if (!treeIds.treeId) return null
    return <Box>{`${treeIds.treeId}:${treeIds.versionId}`}</Box>
  }

  if (tree) {
    return (
      <Box padding="5px" border="solid 1px">
        <Box>
          Swapping Editable Tree <Button onClick={cancel}>Cancel</Button>
          <Button onClick={doIt}>Do Swap</Button>
        </Box>
        <Box>Confirm info is correct for tree to swap to.</Box>
        <TreeIds />
        <Box>{tree.title}</Box>
        <EditableCurriculaTree tree={tree} />
      </Box>
    )
  }

  if (treeIds.treeId)
    return (
      <Box>
        <TreeIds />
        Loading...
      </Box>
    )

  return (
    <Box padding="5px" border="solid 1px">
      <Button onClick={cancel}>Cancel</Button>
      <Box>
        {`Paste in tree ids to swap to. You'll get a chance to edit metadata.`}
      </Box>
      <TreeIdInput
        onChange={({ treeId, version: versionId }) =>
          setTreeIds({ treeId, versionId })
        }
      />
    </Box>
  )
}
